import { EventEmitter } from '@angular/core';

export class StateResetService {
    static onReset = new EventEmitter<void>();
    static reset(): void {
        this.onReset.emit();
    }
}
